export default "__VITE_ASSET__lkq$3bcW__"